import script from "./EditChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./EditChoice.vue?vue&type=script&setup=true&lang=js"

import "./EditChoice.vue?vue&type=style&index=0&id=60ec6c02&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ec6c02"]])

export default __exports__